// Canvas/Three.js animation loops run outside CSS, so the global
// prefers-reduced-motion rule in index.css can't reach them — components with
// their own rAF loop (StarfieldBackground, GreenhouseDome) should check this
// directly and render a single still frame instead of animating continuously.
export function prefersReducedMotion() {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}
